export const apiConfig = {
  LOGIN: '/admins/login',
};
